import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { trackPageView } from "@/utils/tracking";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Celebrations from "@/pages/Celebrations";
import Venues from "@/pages/Venues";
import Checklist from "@/pages/Checklist";
import Portfolio from "@/pages/Portfolio";
import Packages from "@/pages/Packages";
import Process from "@/pages/Process";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import AdminInquiries from "@/pages/AdminInquiries";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Let layout settle, then scroll to the hash target
      const id = hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 8) {
          setTimeout(() => tryScroll(attempt + 1), 80);
        }
      };
      // Initial delay to allow route content to mount
      setTimeout(() => tryScroll(), 60);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname, hash]);

  // Fire SPA virtual page-view after the new route's <title> is rendered by Helmet
  useEffect(() => {
    const t = setTimeout(() => trackPageView(pathname + (hash || "")), 80);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}

function Shell() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/celebrations" element={<Celebrations />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/checklist" element={<Checklist />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/process" element={<Process />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminInquiries />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
